import {Component, Input, OnInit} from "@angular/core";
import {TeArtefactObjectBaseComponent} from "../te-artefact-object-base.component";
import {TeArtefactDto} from "../../../../../model/dto/entity/te-artefact.dto";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";

@Component({
    selector: 'te-artefact-object-full',
    templateUrl: './te-artefact-object-full.component.html',
    styleUrls: ['./te-artefact-object-full.component.scss'],
    standalone: false
})

export class TeArtefactObjectFullComponent extends TeArtefactObjectBaseComponent implements OnInit{
    @Input() dto : TeArtefactDto;

    navigationItems: NavigationItem[] = [
        { label: 'Editor', action: 'Editor', icon: 'fa-regular fa-pen-to-square', default: true, toggleable: false },
        { label: 'Test & Vorschau', action: 'Testen', icon: 'fa-regular fa-flask-vial', toggleable: false },
    ];

    leftPanelTabs: { label: string; action: string; icon: string }[] = [
        { label: 'Variablen', action: 'Variablen', icon: 'fa-regular fa-folder' },
        { label: 'Basisdaten', action: 'Basisdaten', icon: 'fa-regular fa-circle-info' },
    ];
    activeLeftPanelTab: { label: string; action: string; icon: string };
    activeLeftPanelTabValue: string = '0';
    splitterSizes: number[] = [30, 70];
    isSplitterResizing: boolean = false;

    ngOnInit() {
        super.ngOnInit();
        this.activeLeftPanelTab = this.leftPanelTabs[0];
        this.handleToggleBasicData();
    }

    onLeftPanelTabChange(value: string | number): void {
        this.activeLeftPanelTabValue = String(value);
        const index = parseInt(String(value), 10);
        this.activeLeftPanelTab = this.leftPanelTabs[index];
        this.updateSplitterSizes();
    }

    protected updateSplitterSizes(): void {
        if (this.activeNavigationItem?.action === 'Testen') {
            this.splitterSizes = [40, 60];
        } else {
            this.splitterSizes = [35, 65];
        }
    }

    onNavigationItemChange(navigationItem: NavigationItem): void {
        this.updateSplitterSizes();
    }

    onSplitterResizeStart() {
        this.isSplitterResizing = true;
    }

    onSplitterResizeEnd() {
        this.isSplitterResizing = false;
    }
}